import React from "react";
import { AsynchronousTagProps } from "../../types/common";
import AsynchronousTags from "./Asynchronous/AsynchronousTags";
import { TagType } from "../../types/api/tag";

const TagSelect = ({
    onChange,
    value,
    callbackResult,
    type,
    enableAdd,
    label,
    isDocTagsOnly,
}: Omit<AsynchronousTagProps, "onChange"> & { onChange: (value: string) => void; type: TagType }) => {
    return (
        <AsynchronousTags
            onChange={item => {
                onChange(item ?? "");
            }}
            value={value}
            type={type}
            label={label}
            callbackResult={callbackResult}
            enableAdd={enableAdd}
            isDocTagsOnly={isDocTagsOnly}
        />
    );
};

export default TagSelect;
